<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <v-form ref="form">
      <v-row class="pb-7">
        <v-col cols="12">
          <p class="form__title mb-6 primary--text">
            INSERIR APÓLICE
          </p>
        </v-col>
        <v-col cols="12" sm="7" md="8" class="pr-sm-5">
          <BaseFormInput
            id-element="numberNewPolicy"
            placeholder="0000000000"
            v-model="form.numero"
            required
            :rules="[requiredInput]"
            label-text="N° da Apólice"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3" class="pt-sm-8">
          <BaseButton
            color="secondary"
            width="100%"
            @click="showModalCoInsurance"
          >
            <v-icon class="pr-2" size="20">
              fa-plus
            </v-icon>
            INCLUIR COSSEGURO
          </BaseButton>
        </v-col>
        <v-col cols="12" sm="4" class="pr-sm-5">
          <BaseFormInput
            id-element="emissionNewPolicy"
            placeholder="DD/MM/AAAA"
            v-model="form.emitida_em"
            required
            :rules="[requiredInput, dateTermValid]"
            validate-on-blur
            v-facade="maskDate"
            label-text="Data da Emissão"
          />
        </v-col>
        <v-col cols="12" sm="4" class="pr-sm-5">
          <BaseFormInput
            id-element="startTermNewPolicy"
            placeholder="DD/MM/AAAA"
            v-model="form.inicio_vigencia"
            required
            :rules="[requiredInput, dateTermValid]"
            validate-on-blur
            v-facade="maskDate"
            label-text="Início da Vigência"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <BaseFormInput
            id-element="endTermNewPolicy"
            placeholder="DD/MM/AAAA"
            v-model="form.fim_vigencia"
            required
            :rules="[requiredInput, dateTermValid]"
            validate-on-blur
            v-facade="maskDate"
            label-text="Final da Vigência"
          />
        </v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <PolicyFormSection
        :form="form"
        :error-messages="errorMessages"
        is-policy-without-quotation
      />
      <BaseFooter>
        <v-row>
          <v-spacer />
          <v-col cols="6" sm="4" md="3" xl="2" class="pr-5">
            <BaseButton
              v-html="'CANCELAR'"
              color="secondary"
              width="100%"
              outlined
              @click="previousPage"
            />
          </v-col>
          <v-col cols="6" sm="4" md="3" xl="2">
            <BaseButton
              v-html="'ENVIAR'"
              class="white--text secondary"
              width="100%"
              @click="submit"
            />
          </v-col>
        </v-row>
      </BaseFooter>
    </v-form>
    <ModalCoInsurance
      v-if="modalCoInsurance"
      v-model="modalCoInsurance"
      @close="closeModal"
      @submit="newCoInsuranceItems"
      :items="form.cosseguros"
      :policy-insurance="currentQuotation.minuta.seguradora"
    />
    <ModalGenericCriticism
      v-model="modal"
      @close="previousPage"
      title="DOCUMENTOS INSERIDOS"
      text="O arquivo de Apólice e Boletos foram inseridos
            com sucesso!"
    />
    <ModalCancelPolicy
      @close="closeModalCancel"
      v-model="modalCancel"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
import ModalGenericCriticism from "../components/ModalGenericCriticism";
import { requiredInput, dateTermValid } from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { mapState, mapActions } from "vuex";
import { FILE, documentAlreadyUploaded } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import PolicyFormSection from "@/components/form/PolicyFormSection";
import _ from "lodash";
import ModalCoInsurance from "@/components/ModalCoInsurance";
import {
  formatDDMMYYYYToIsoDate,
  formatDateToDDMMYYYY
} from "@/utils/formats.js";
import ModalCancelPolicy from "../../insurance_company/components/ModalCancelInsurance";
import FormMixin from "@/mixins/FormMixin";
export default {
  beforeRouteLeave(to, from, next) {
    if (this.cancel || this.formIsPristineCommon(this.form, this.cloneForm))
      next();
    this.modalCancel = true;
    this.nextRoute = to;
  },
  data: () => ({
    form: {
      numero: null,
      emitida_em: null,
      cosseguros: [],
      inicio_vigencia: null,
      fim_vigencia: null,
      forma_pagamento: null,
      data_vencimento: null,
      numero_parcela: null,
      parcelas: [],
      percentual_comissao: null,
      taxa_premio: 0,
      apolice: [],
      boletos: [],
      valor_premio: 0
    },
    dateTermValid,
    maskDate,
    errorMessages: [],
    breadcrumb: [
      {
        text: "Cotação - ",
        to: "quotation element"
      }
    ],
    requiredInput,
    modal: false,
    modalCoInsurance: false,
    formatDDMMYYYYToIsoDate,
    formatDateToDDMMYYYY,
    cancel: false,
    modalCancel: false,
    nextRoute: null,
    cloneForm: {}
  }),
  components: {
    ModalGenericCriticism,
    PolicyFormSection,
    ModalCoInsurance,
    ModalCancelPolicy
  },
  created() {
    this.fetchItems();
  },
  computed: {
    ...mapState("quotation", ["currentQuotation"])
  },
  mixins: [LoadingRequest, DocumentsMixin, FormMixin],
  methods: {
    ...mapActions("quotation", [
      "requestCurrentQuotation",
      "requestNewPolicy",
      "requestInsuranceCompanyQuotation"
    ]),
    ...mapActions("insuranceCompany", ["requestPaymentMethods"]),
    ...mapActions(["showAlertNotification"]),
    previousPage() {
      this.modal = false;
      this.$router.push({
        name: "quotation element",
        params: { id: this.$route.params.id }
      });
    },
    fetchQuotation() {
      if (_.isEmpty(this.currentQuotation)) {
        this.withLoading(this.requestCurrentQuotation(this.$route.params.id));
      } else {
        this.updateBreadcrumb();
        this.updateForm();
      }
    },
    fetchInsuranceCompany() {
      this.withLoading(
        Promise.all([
          this.requestInsuranceCompanyQuotation(),
          this.requestPaymentMethods()
        ])
      );
    },
    fetchItems() {
      Promise.all([this.fetchInsuranceCompany(), this.fetchQuotation()]);
    },
    validate() {
      if (this.form.apolice.length == 0) {
        this.errorMessages = ["É preciso adicionar a apólice"];
      } else {
        this.errorMessages = [];
      }
      return (
        this.$refs.form.validate() &&
        this.form.apolice.length > 0 &&
        this.validateInstallments()
      );
    },
    validateInstallments() {
      // Caso o valor do premio dê diferente das parcelas, ou o valor_premio
      // foi alterado e precisa ser refeito o cálculo do premio ou não foi
      // feito nenhuma vez o cálculo do prêmio e precisa ser feito
      const validate =
        _.round(this.form.valor_premio, 1) ===
        _.round(_.sumBy(this.form.parcelas, "valor"), 1);
      if (!validate) {
        this.showAlertNotification({
          message:
            "É preciso calcular/recalcular o prêmio antes de finalizar processo.",
          type: "error"
        });
      }
      return validate;
    },
    async submit() {
      if (!this.validate()) return;
      this.form.apolice = await this.submitFiles(this.form.apolice);
      this.form.boletos = _.map(
        await this.submitFiles(this.form.boletos),
        "arquivo"
      );

      if (this.form.boletos !== null) {
        for(var i=0;i<this.form.boletos.length;++i) {
          if(this.isEmptyOrSpaces(this.form.boletos[i].url)) {
            this.showAlertNotification({
              message: `Não foi possível enviar o boleto ${this.form.boletos[i].nome}. Por favor tente novamente.`,
              type: "error"
            });

            return;
          }
        }
      }

      this.withLoading(
        this.requestNewPolicy(this.getPayloadPolicy()).then(() => {
          this.cancel = true;
          this.modal = true;
        })
      );
    },
    isEmptyOrSpaces(str){
      return str === null || str.match(/^ *$/) !== null;
    },
    submitFiles(item) {
      const { uploadDocument } = this;
      return Promise.all(
        _.map(item, document =>
          documentAlreadyUploaded(document)
            ? Promise.resolve(document)
            : uploadDocument(document.arquivo[FILE], (file, arquivo) => ({
                arquivo
              }))
        )
      );
    },
    getPayloadPolicy() {
      let payload = _.pick(_.cloneDeep(this.form), [
        "numero",
        "cosseguros",
        "emitida_em",
        "inicio_vigencia",
        "fim_vigencia",
        "valor_premio",
        "forma_pagamento",
        "parcelas",
        "percentual_comissao",
        "taxa_premio",
        "boletos",
        "valor_importancia_segurada"
      ]);
      payload.arquivo = _.cloneDeep(this.form.apolice[0].arquivo);
      payload.emitida_em = this.formatDDMMYYYYToIsoDate(payload.emitida_em);
      payload.inicio_vigencia = this.formatDDMMYYYYToIsoDate(
        payload.inicio_vigencia
      );
      payload.fim_vigencia = this.formatDDMMYYYYToIsoDate(payload.fim_vigencia);
      payload.cosseguros.forEach(
        item => (item.participacao = parseFloat(item.participacao))
      );
      payload.parcelas.forEach(item => {
        item.vencimento = this.formatDDMMYYYYToIsoDate(item.vencimento);
        item.numero = item.numero.toString();
      });
      payload.percentual_comissao = parseFloat(payload.percentual_comissao);
      return {
        id: this.$route.params.id,
        payload: payload
      };
    },
    updateForm() {
      this.form.forma_pagamento =
        this.currentQuotation.apolice.forma_pagamento &&
        _.cloneDeep(this.currentQuotation.apolice.forma_pagamento);
      this.form.valor_premio = _.cloneDeep(this.currentQuotation.minuta.valor);
      this.form.fim_vigencia = this.formatDateToDDMMYYYY(
        this.currentQuotation.apolice.fim_vigencia
      );
      this.form.inicio_vigencia = this.formatDateToDDMMYYYY(
        this.currentQuotation.apolice.inicio_vigencia
      );
      this.form.emitida_em = this.formatDateToDDMMYYYY(
        this.currentQuotation.minuta.emitida_em
      );
      this.form.valor_importancia_segurada = _.cloneDeep(
        this.currentQuotation.apolice.valor_importancia_segurada
      );
      this.cloneForm = _.cloneDeep(this.form);
    },
    updateBreadcrumb() {
      this.breadcrumb = [
        {
          text: `Cotação - ${this.currentQuotation.numero}`,
          to: "quotation element"
        }
      ];
    },
    showModalCoInsurance() {
      this.modalCoInsurance = true;
    },
    newCoInsuranceItems(item) {
      this.closeModal();
      this.form.cosseguros = item;
    },
    closeModal() {
      this.modalCoInsurance = false;
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({
          name: this.nextRoute.name,
          params: this.nextRoute.params
        });
      }
    }
  },
  watch: {
    currentQuotation() {
      this.updateBreadcrumb();
      this.updateForm();
    }
  }
};
</script>
